module.exports = __webpack_public_path__ + "static/img/v4.87f95edb.jpg";